import React from "react";
import { Col, Row, Spinner } from "react-bootstrap";

const CustomSpinner = ({
  className = "w-100 d-flex justify-content-center align-items-center",
}) => {
  return (
    <Row className={` ${className}`} style={{ height: "80vh" }}>
      <Col className="text-center">
        <Spinner animation="grow" />
      </Col>
    </Row>
  );
};

export default CustomSpinner;
